import {
  checkNotBlank,
  checkedNotSellsyMail,
  checkIsTrue,
  checkIsValidPassword,
  checkContainNoNumber,
} from './Rules';

export default {
  login: [
    { required: true, message: window.i18n.__('Veuillez saisir un email'), trigger: 'blur' },
    {
      type: 'email',
      message: window.i18n.__('Veuillez saisir une adresse email valide'),
      trigger: 'blur',
    },
    {
      validator: checkedNotSellsyMail,
      message: window.i18n.__('Veuillez saisir une adresse email valide'),
      trigger: 'blur',
    },
  ],
  terms: [
    {
      required: true,
      message: window.i18n.__('Veuillez accepter les conditions'),
      trigger: 'change',
    },
    {
      validator: checkIsTrue,
      message: window.i18n.__('Veuillez accepter les conditions'),
      trigger: 'change',
    },
  ],
  password: [{ validator: checkIsValidPassword, message: ' ', trigger: 'blur' }],
  name: [
    {
      validator: checkNotBlank,
      message: window.i18n.__('Veuillez saisir un nom de société'),
      trigger: ['blur', 'change'],
    },
  ],
  firstname: [
    {
      validator: checkNotBlank,
      message: window.i18n.__('Veuillez saisir un prénom'),
      trigger: ['blur', 'change'],
    },
    {
      validator: checkContainNoNumber,
      message: window.i18n.__('Le prénom ne doit pas contenir de chiffre'),
      trigger: ['blur', 'change'],
    },
  ],
  lastname: [
    {
      validator: checkNotBlank,
      message: window.i18n.__('Veuillez saisir un nom'),
      trigger: ['blur', 'change'],
    },
    {
      validator: checkContainNoNumber,
      message: window.i18n.__('Le nom ne doit pas contenir de chiffre'),
      trigger: ['blur', 'change'],
    },
  ],
  phone_number: [
    {
      validator: checkNotBlank,
      message: window.i18n.__('Veuillez saisir un numéro de téléphone valide'),
      trigger: ['blur', 'change'],
    },
  ],
  country: [
    {
      validator: checkNotBlank,
      message: window.i18n.__('Veuillez saisir un pays'),
      trigger: ['blur', 'change'],
    },
  ],
  lang: [
    {
      validator: checkNotBlank,
      message: window.i18n.__('Veuillez saisir une langue'),
      trigger: ['blur', 'change'],
    },
  ],
};
